import React, { useState, useEffect } from 'react';
import Button from '../components/Button';
import styled from 'styled-components';
import sauceBlob from '../assets/img/sauce-blob.png';
import burger from '../assets/img/home-burger.png';
import cheese from '../assets/img/home-cheese.png';
import lettuce from '../assets/img/home-lettuce.png';

const HomeWrapper = styled.div`
  position: relative;
  margin-top: -58px;
  margin-left: -16px;
  padding-left: 16px;

  > div {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  > img {
    z-index: 0;

    &#img_burger {
      position: absolute;
      top: 0;
      right: -16px;
      z-index: 0;
      width: 256px;
      transition: transform 0.5s ease-out 0.5s;
      transform: translate(250px, -250px);
    }

    &#img_cheese {
      position: absolute;
      bottom: 0;
      left: 0;
      transition: transform 0.5s ease-out 0.7s;
      transform: translate(-250px, 250px);
    }

    &#img_lettuce {
      position: absolute;
      bottom: 0;
      right: -16px;
      z-index: 0;
      transition: transform 0.5s ease-out 0.9s;
      transform: translate(250px, 250px);
    }
  }

  &.animate > img {
    &#img_burger, 
    &#img_cheese,
    &#img_lettuce  {
      transform: translate(0, 0);
    }
  }
`;

const IntroWrapper = styled.div`
  // flex: 1;
  flex-direction: column;
  position: relative;
  z-index: 5;

    > h2 {
      font-family: 'Speedee Bold';
      font-size: 80px;
      line-height: 0.95em;
      letter-spacing: -0.03em;
      margin: 16px 0 0;

      > span {
        display: block;
        opacity: 0;
    
        > span {
          position: relative;
    
          &:after {
            content: '';
            position: absolute;
            width: 205px;
            height: 100px;
            bottom: -36px;
            right: -146px;
            background-image: url(${sauceBlob});
            background-repeat: no-repeat;
            background-position: center; 
          }
        }
      }

      .animate & > span {
        opacity: 1;
      }

      > span:nth-child(1) {
        color: #e6a65d;
        transition: opacity 0.2s 0.2s;
      }

      > span:nth-child(2) {
        color: #833921;
        transition: opacity 0.2s 0.4s;
      }

      > span:nth-child(3) {
        color: #a9c23f;
        transition: opacity 0.2s 0.6s;
      }

      > span:nth-child(4) {
        color: #ffbc0d;
        transition: opacity 0.2s 0.8s;
      }
    }
  }
`;

const ActionsWrapper = styled.div`
  width: 100%;
  padding-top: 20px;
  padding-bottom: 110px;
  box-sizing: border-box;
  z-index: 5;

  p {
    font-size: 16px;
    text-align: center;
    margin: 10px 0;
  }
  .tcs {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.15px;
    margin-top: 12px;

    .link {
      text-decoration: underline;
    }
  }
`;

function Home({ ...props }) {
  const { setPage } = props;
  const [isloaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <HomeWrapper className={isloaded ? 'animate' : ''}>
      <div>
        <IntroWrapper>
          <h2>
            <span>The</span>
            <span>Big&nbsp;Mac&reg;</span>
            <span>chant&nbsp;<span>is</span></span>
            <span>back</span>
          </h2>
          <p>
          Recite the Big Mac chant in 4 seconds to win a free Small Fries and Coke!          </p>
        </IntroWrapper>
        <ActionsWrapper>
          <Button onClick={() =>{ setPage('onboarding-chant'); window.gtag('event', 'chant_selection_voice')}}>Play now</Button>
          <p>
            Or try our Big Mac chant tap along
          </p>
          <Button onClick={() => {setPage('onboarding-tap'); window.gtag('event', 'chant_selection_tap')}} theme={'secondary'}>
            Tap along
          </Button>
          <p className='tcs'>
          Ends 7.5.24. Available at participating restaurants. Excludes McDelivery®. Full T&Cs: <a target='_blank' href='https://mcdonalds.com.au/theoriginalmouthful' rel='noreferrer' className='link'>mcdonalds.com.au/theoriginalmouthful</a>. ‘Coca-Cola’, ‘Coke’ are registered trade marks of the Coca-Cola Company.
          </p>
        </ActionsWrapper>
      </div>
      <img id="img_burger" src={burger} alt=""/>
      <img id="img_cheese" src={cheese} alt=""/>
      <img id="img_lettuce" src={lettuce} alt=""/>
    </HomeWrapper>
  );
}

export default Home;
